
import { PitchTypePricingResult } from '../../../../apps/search/types'
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'

@Component
export default class PuPricingResults extends Vue {
  @Prop()
    pitchtypes: PitchTypePricingResult[]

  @Prop()
    searchResultIndex: number

  @Prop()
    numberOfPitchtypesToShow: number

  showPitchesExpanded = false

  get pitchtypesSectionId() {
    return `pitchtypes${this.searchResultIndex}`
  }

  showMorePitches() {
    this.showPitchesExpanded = !this.showPitchesExpanded
  }
}
